import React from 'react';

import _ from 'lodash';

import { EntityModules } from 'core/constants';

import { EntityHistoryResponseType } from 'utils/api/modules/entities/entities.types';

import HistoryRow from './HistoryRow';
import { HistoryParagraph } from './utils';

const ENTITY_LABELS: Record<EntityModules, string> = {
  [EntityModules.Assets]: 'asset',
  [EntityModules.Sites]: 'site',
  [EntityModules.Contacts]: 'contact',
  [EntityModules.RisksAssessments]: 'risk assessment',
  [EntityModules.Events]: 'event',
  [EntityModules.Documents]: 'document',
  [EntityModules.Risks]: 'risk record',
  [EntityModules.Audits]: 'record',
  [EntityModules.Controls]: 'control',
  [EntityModules.Hazards]: 'hazard',
};

const CreatedAtRow = ({
  item,
  entityType,
}: {
  item: EntityHistoryResponseType;
  entityType: EntityModules;
}): React.ReactElement => {
  const { createdBy, current, entityField, createdAt } = item;
  const entityLabel = ENTITY_LABELS[entityType];

  let content: React.ReactNode;

  // If user_name is missing (e.g. system/import): <Entity> created
  if (createdBy === null) {
    content = `${_.upperFirst(entityLabel)} created`;
  }

  // If form_name is missing: <user_name> created this <entity>
  else if (current === null) {
    content = (
      <>
        {createdBy.name ? <b>{createdBy.name}</b> : <b>N/A</b>}
        {` created this ${entityLabel}`}
      </>
    );
  }

  // Default: <user_name> reported this event via <form_name>
  else {
    content = (
      <>
        {createdBy.name ? <b>{createdBy.name}</b> : <b>N/A</b>}
        {` reported this ${entityLabel} via `}
        {current ? <b>{current as string}</b> : <b>N/A</b>}
      </>
    );
  }

  return (
    <HistoryRow item={item}>
      <HistoryParagraph key={`${entityField}-${createdAt}`}>{content}</HistoryParagraph>
    </HistoryRow>
  );
};

export default CreatedAtRow;
